import {  
  loadEnumDataInProgress,
  loadEnumDataSuccess,
  loadEnumDataFailure,
  enumOperationCompleted,
  loadEnumSingleData,
} from "../state/enums/actions";
import swal from 'sweetalert';
import configData from "../config.json";
import { errorSweetAlert, fileSchemaSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
const serverBasePath=configData.SERVER_API_URL;


export const loadEnumsList = (page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadEnumDataInProgress());
    const response = await fetch(serverBasePath+"/enums/getEnumsList?page="+page+"&pageSize="+pageSize,
    {
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadEnumDataSuccess(result));
  } catch (e) {
    dispatch(loadEnumDataFailure());
    errorSweetAlert(e); 
  }
};

export const addNewEnumsFile = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadEnumDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/enums/addNewEnumsFile", 
      {
        method: "POST",  
        headers: {
          Authorization: 'Bearer ' + token,       
          'type': 'formData',
        },
        body:data
      });
      dispatch(enumOperationCompleted());
      const result = await response.json();
      if(response.status === 500 && result?.errors){
          fileSchemaSweetAlert(result);
          return;
      }
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      //dispatch(closeUnitsAndEnumsDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadEnumsList(''));
        }
      });
  } catch (e) {
      dispatch(loadEnumDataFailure());
      errorSweetAlert(e);
  }
};


export const deleteEmums = (id) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadEnumDataInProgress());
          const response = await fetch(serverBasePath+"/enums/delete/"+id,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(enumOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadEnumsList(''));
              }
          });
      } catch (e) {   
          dispatch(loadEnumDataFailure());
          errorSweetAlert(e); 
      }
  };
};


export const setLatestEmums = (rowId) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token'); 
      try {
          dispatch(loadEnumDataInProgress());
          const response = await fetch(serverBasePath+"/enums/"+rowId+"/setlatest",
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(enumOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadEnumsList(''));
              }
          });
      } catch (e) {   
          dispatch(loadEnumDataFailure());
          errorSweetAlert(e); 
      }
  };
};

export const loadEnumEditData = (rowId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadEnumDataInProgress());
        const response = await fetch(serverBasePath+"/enums/getEnumContent/"+rowId,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(enumOperationCompleted()); 
        const data = await response.json();
        if(response.status !== 200){
            swal({
              title: 'Oops!',
              text: "There is some error while fetching the data. Please try again.",
              icon: "error",
              dangerMode: true,
          });
            return;
        }
        dispatch(loadEnumSingleData(data));   
    } catch (e) {
        dispatch(loadEnumDataFailure());   
        errorSweetAlert(e);
    }
};


export const downloadEnumFile = (rowId,fileName) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken(); 
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadEnumDataInProgress());
            const response = await fetch(serverBasePath+"/enums/"+rowId+"/download",
            {
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(enumOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`${fileName}.json`); 
            document.body.appendChild(link);
            link.click();
            dispatch(enumOperationCompleted()); 
        } catch (e) {   
            dispatch(loadEnumDataFailure());
            errorSweetAlert(e);  
        }
    };
};
